'use strict';

var react = require('@sentry/react');

function captureException(exception, hint) {
  return react.captureException(exception, hint);
}

exports.captureException = captureException;
//# sourceMappingURL=captureException.cjs.map
